export default __webpack_public_path__ + "static/media/Services-4.c1e7c83d.jpg";